module.exports = __webpack_public_path__ + "static/media/about-image-company.cd035e07.jpg";